import React from 'react';
import VendorsByCategory from './ChartsList/VendorsByCategory';
import MultipleDiversity from './ChartsList/MultipleDiversity';
import UsaHeatmap from './ChartsList/UsaHeatmap';

const ChartsWrapper = () => {
	return (
		<>
			<VendorsByCategory />
			<UsaHeatmap />
			<MultipleDiversity />
		</>
	);
};

export default ChartsWrapper;
